'use client'

import { useHydrated } from '@/hooks/common/use-hydrated'
import { useConsentManager } from '@c15t/nextjs'
import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'

const FlowOnboard = dynamic(
  () =>
    import('@/components/layout/flow-onboard/index').then(
      (mod) => mod.FlowOnboard
    ),
  {
    ssr: false,
  }
)

const PopupSetting = dynamic(
  () =>
    import('@/components/layout/popup-setting/index').then(
      (mod) => mod.PopupSetting
    ),
  {
    ssr: false,
  }
)

const ReferFriend = dynamic(
  () =>
    import('@/components/layout/refer-friend/index').then(
      (mod) => mod.ReferFriend
    ),
  {
    ssr: false,
  }
)

const PopupVoucherBirthday = dynamic(
  () =>
    import('@/components/layout/popup-voucher/index').then(
      (mod) => mod.PopupVoucherBirthday
    ),
  {
    ssr: false,
  }
)

export const PopupFirstLoad = () => {
  const pathname = usePathname()
  const { hasConsented } = useConsentManager()
  const hydrated = useHydrated()
  if (pathname.includes('/doi-tra')) return null
  // Chờ user xử lý cookie banner xong mới mount popup — các popup là Radix
  // modal (focus trap + body pointer-events: none) sẽ tranh focus với banner.
  if (!hydrated || !hasConsented()) return null

  return (
    <>
      <FlowOnboard />
      <PopupSetting />
      <ReferFriend />
      <PopupVoucherBirthday />
    </>
  )
}
